import clsx from 'clsx';
import {flushSync} from 'react-dom';
import {createRoot} from 'react-dom/client';

type Props = React.HTMLAttributes<HTMLDivElement>;

export function makeMarkerVariantFactory() {
  const div = document.createElement('div');
  const root = createRoot(div);

  return function createMarkerVariant({children, className, ...props}: Props) {
    flushSync(() => {
      root.render(
        <div {...props} className={clsx('relative', className)}>
          <div className="absolute-center flex items-center justify-center">
            {children}
          </div>
        </div>
      );
    });

    return div.innerHTML;
  };
}
